module.exports = __webpack_public_path__ + "static/cosygsheepmain-62e23b6e7350736653e6bd5e357b6c54.jpeg";